import { Line } from 'react-chartjs-2';
import { useTranslation } from 'react-i18next';
import { EmptyLineOrBarChart } from 'src/common/components/Graphs/common/Graphs/EmptyLineOrBarChart';

type AreaChartSomethingWrongProps = {
  xAxisLabels?: string[];
};

export const AreaChartSomethingWrong = ({ xAxisLabels }: AreaChartSomethingWrongProps) => {
  const { t } = useTranslation();
  return (
    <EmptyLineOrBarChart
      as={Line}
      emptyChartText={t('common.somethingWrong')}
      xAxisLabels={xAxisLabels}
    />
  );
};
